(() => {
  const visibleLightboxSelector = [
    '.gk-lightbox:not([hidden])',
    '.curler-lightbox:not([hidden])',
    '[data-lightbox]:not([hidden])',
  ].join(',');

  const hasOpenOverlay = () => Boolean(document.querySelector([
    'cart-drawer.active',
    'details-modal[open]',
    'pickup-availability-drawer[open]',
    'menu-drawer details[open]',
    visibleLightboxSelector,
  ].join(',')));

  const restorePageScroll = () => {
    const menuIsOpen = Boolean(document.querySelector('.header nav.open, .mirthly-nav.open'));
    const lightboxIsOpen = Boolean(document.querySelector(visibleLightboxSelector));

    if (!menuIsOpen) document.body.classList.remove('mirthly-menu-open');
    if (!lightboxIsOpen) document.body.classList.remove('mirthly-lightbox-open');

    if (!hasOpenOverlay()) {
      document.body.classList.remove(
        'overflow-hidden',
        'overflow-hidden-mobile',
        'overflow-hidden-tablet',
        'overflow-hidden-desktop',
      );
      if (document.body.style.overflow === 'hidden') document.body.style.removeProperty('overflow');
      if (document.body.style.position === 'fixed') document.body.style.removeProperty('position');
      if (document.body.style.touchAction === 'none') document.body.style.removeProperty('touch-action');
      if (document.documentElement.style.overflow === 'hidden') document.documentElement.style.removeProperty('overflow');
      if (document.documentElement.style.touchAction === 'none') document.documentElement.style.removeProperty('touch-action');
    }
  };

  const resetEditorialMenu = () => {
    document.querySelectorAll('.mirthly-nav.open').forEach(nav => nav.classList.remove('open'));
    document.querySelectorAll('.header .menu.open').forEach(menu => {
      menu.classList.remove('open');
      menu.setAttribute('aria-expanded', 'false');
      menu.setAttribute('aria-label', 'Open menu');
    });
    document.body.classList.remove('mirthly-menu-open');
  };

  let pending;
  const scheduleRestore = () => {
    window.clearTimeout(pending);
    pending = window.setTimeout(restorePageScroll, 80);
  };

  window.addEventListener('pagehide', resetEditorialMenu);
  window.addEventListener('beforeunload', resetEditorialMenu);
  window.addEventListener('pageshow', () => {
    resetEditorialMenu();
    restorePageScroll();
  });
  window.addEventListener('popstate', scheduleRestore);
  window.addEventListener('orientationchange', scheduleRestore);
  window.addEventListener('resize', scheduleRestore, { passive: true });
  document.addEventListener('click', scheduleRestore, true);
  document.addEventListener('keyup', event => {
    if (event.key === 'Escape') scheduleRestore();
  });
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) scheduleRestore();
  });

  new MutationObserver(scheduleRestore).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class', 'style'],
    childList: true,
    subtree: true,
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restorePageScroll, { once: true });
  } else {
    restorePageScroll();
  }
})();
